import {validateValue} from '../helpers/validation'

// Begin action types
export const FETCH_PROFILE_ACTOR_DATA_SUCCESS = 'FETCH_PROFILE_ACTOR_DATA_SUCCESS'
export const VALIDATE_PROFILE_ACTOR_FIELD = 'VALIDATE_PROFILE_ACTOR_FIELD'
export const SUBMIT_PROFILE_ACTOR_FIELDS = 'SUBMIT_PROFILE_ACTOR_FIELDS'
export const CLEAR_PROFILE_ACTOR_FIELDS = 'CLEAR_PROFILE_ACTOR_FIELDS'
// End action types

export const fetchProfileActorDataSuccess = (data) => ({
  type: FETCH_PROFILE_ACTOR_DATA_SUCCESS,
  data
});
export const validateProfileActorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_PROFILE_ACTOR_FIELD,
    field
  }
}
export const submitProfileActorFields = (fields) => {
  return {
    type: SUBMIT_PROFILE_ACTOR_FIELDS,
    fields
  }
}
export const clearProfileActorFields = () => {
  return {
    type: CLEAR_PROFILE_ACTOR_FIELDS
  }
}
